import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Breadcrumb } from "antd";
import { IMG_DEFAULT, MyIcon } from "../../common/baseConfig";
import moment from "moment";
import * as actions from './redux/actions';

export class TeacherDetail extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    showAll: false,
  }
  componentDidMount() {
    let ID = this.props.match.params.id;
    //获取老师信息
    this.props.actions.fetchGetTeacherInfo({ ID });
    //获取老师答疑
    this.props.actions.fetchGetTeacherAnswer({ ID });
    //获取相关名师
    this.props.actions.fetchGetTeacherAbout({ ID });
  }
  render() {
    const {
      fetchGetTeacherInfoSuccess,
      fetchGetTeacherAnswerSuccess,
      fetchGetTeacherAboutSuccess,
    } = this.props.common;
    const { showAll } = this.state;
    let AnswerData = fetchGetTeacherAnswerSuccess;
    if (AnswerData && AnswerData.length > 0) {
      AnswerData = AnswerData.slice(0, 4);
    }
    if (showAll) {
      AnswerData = fetchGetTeacherAnswerSuccess;
    }
    let Teachers = fetchGetTeacherAboutSuccess && fetchGetTeacherAboutSuccess.length > 0 && fetchGetTeacherAboutSuccess.slice(0, 5);
    let Data = fetchGetTeacherInfoSuccess;
    return (
      <div className="common-teacher-detail">
        <div className="common-teacher-banner">
          <div className="common-teacher-banner-inner">
            <div className="common-teacher-breadcrumb">
              <Breadcrumb separator=">">
                <Breadcrumb.Item href="/">网校</Breadcrumb.Item>
                <Breadcrumb.Item href="/teachers">师资阵容</Breadcrumb.Item>
                {
                  Data && <Breadcrumb.Item>{Data.Name}</Breadcrumb.Item>
                }
              </Breadcrumb>
            </div>
            {
              Data && <div className="common-teacher-intro">
                <div className="common-teacher-content">
                  <p className="name">
                    <span>{Data.Name || "匿名"}</span><span>{Data.Title || ""}</span>
                  </p>
                  <p className="intro" dangerouslySetInnerHTML={{ __html: Data.introduction }} />
                </div>
              </div>
            }
            <div className="common-teacher-photo">
              {
                Data && Data.ImagePhoto && <img src={Data.ImagePhoto ? Data.ImagePhoto + '?x-oss-process=image/resize,m_fixed,h_400,w_288' : ''} alt="" />
              }
            </div>
          </div>
        </div>
        <div className="common-teacher-courses">
          <div className="common-teacher-courses-inner">
            <h1>{'//'}相关课程{'//'}</h1>
            {
              Data && Data.TeacherCourseList.length > 0 && <div className="common-teacher-courses-list">
                {
                  Data.TeacherCourseList.map(item => (
                    <div key={item.ID} className="common-teacher-courses-list-item" onClick={() => {
                      this.props.history.push(`/course/detail/${item.ID}`);
                    }}>
                      <img src={item.CoverPath ? item.CoverPath + '?x-oss-process=image/resize,m_fixed,h_158,w_283' : IMG_DEFAULT} alt="" />
                      <p className="tit">
                        {item.Name}-{item.TeacherName}
                      </p>
                      <p className="content">
                        <span>{item.PreferentialPrice === 0 ? "免费" : `¥ ${item.PreferentialPrice}`}</span>
                        <span>
                          <MyIcon type="iconrenshu" className="count" />
                          {item.BuyBase + item.BuyCount}
                        </span>
                      </p>
                    </div>
                  ))
                }
              </div>
            }
          </div>
        </div>
        {
          AnswerData && AnswerData.length > 0 && <div className="common-teacher-answer">
            <h1>{'//'}相关答疑{'//'}</h1>
            <div className="common-teacher-answer-content">
              {
                AnswerData.map((item, key) => (<div key={key} className="answer-item">
                  <div className="answer">
                    <div className="top">
                      <p>问</p>
                      <span className="name">{item.Question.Name}</span>
                      <span className="time">{moment(item.AnswerList[0].AddTime).format("YYYY-MM-DD HH:mm:ss")}</span>
                    </div>
                    <div className="bottom">
                      {item.Question.Content}
                    </div>
                  </div>
                  {
                    item.AnswerList.length > 0 && item.AnswerList.map((it, i) => (
                      <div className="reply" key={i}>
                        <div className="top">
                          <p>答</p>
                          {Data && <span className="name">{Data.Name || "匿名"}</span>}
                          <span className="time">{moment(it.Answertime).format("YYYY-MM-DD HH:mm:ss")}</span>
                        </div>
                        <div className="bottom">
                          {it.Answer}
                        </div>
                      </div>
                    ))
                  }
                  <p className="source">来源：{item.Question.CourseName}</p>
                </div>))
              }
              {
                fetchGetTeacherAnswerSuccess && fetchGetTeacherAnswerSuccess.length > 4 && !showAll && <div className="answer-show-all">
                  <p onClick={() => {
                    this.setState({
                      showAll: true
                    })
                  }}>显示全部内容</p>
                </div>
              }
            </div>
          </div>
        }
        {
          Teachers && <div className="common-relative-teachers">
            <div className="common-relative-teachers-inner">
              <h1>{'//'}相关名师{'//'}</h1>
              <div className="teachers-list">
                {
                  Teachers.map(item => (
                    <div key={item.ID} className="teachers-list-item" onClick={() => {
                      this.props.history.replace(`/teachers/detail/${item.ID}`);
                      window.location.reload();
                    }}>
                      <div className="teachers-list-item-img">
                        {item.ImagePhoto && <img src={item.ImagePhoto} alt="" />}
                      </div>
                      <p className="tit">
                        <span>{item.Name || "匿名"}</span><span>{item.Title || ""}</span>
                      </p>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeacherDetail);



// WEBPACK FOOTER //
// ./src/features/common/TeacherDetail.js